import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function NavBar(): JSX.Element {
	return (
		<div className="NavBarWrapper">
			<Navbar
				expand="lg"
				variant="dark"
				fixed="top"
				className="NavBar"
			>
				<Navbar.Brand className="Name">
					Kumar Mallikarjuna
				</Navbar.Brand>
				<Navbar.Toggle
					aria-controls="basic-navbar-nav"
					className="toggle"
				>
					<FontAwesomeIcon icon={faBars} />
				</Navbar.Toggle>
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="ml-auto">
						<Link
							activeClass="NavItemActive"
							to="greet"
							spy={true}
							smooth={true}
							offset={-70}
							duration={500}
						>
							<Nav.Link className="NavItem">
								HOME
							</Nav.Link>
						</Link>
						<Link
							activeClass="NavItemActive"
							to="experience"
							spy={true}
							smooth={true}
							offset={-70}
							duration={500}
						>
							<Nav.Link className="NavItem">
								EXPERIENCE
							</Nav.Link>
						</Link>
						<Link
							activeClass="NavItemActive"
							to="projects"
							spy={true}
							smooth={true}
							offset={-70}
							duration={500}
						>
							<Nav.Link className="NavItem">
								PROJECTS
							</Nav.Link>
						</Link>
						<Nav.Link
							className="NavItem"
							href="https://drive.google.com/file/d/1907BR9nt4cJGNs5EGV0gyGBW0rAHQao4/view?usp=sharing"
							target="_blank"
						>
							RÉSUMÉ
						</Nav.Link>
						<Nav.Link
							className="NavItem"
							href="https://drive.google.com/file/d/1m0PffVfrCxo2huI4V73B_N2Sqe7PAzPn/view?usp=sharing"
							target="_blank"
						>
							CV
						</Nav.Link>
						<Nav.Link
							className="NavItem"
							href="mailto:kumarmallikarjuna1@gmail.com"
							target="_blank"
						>
							EMAIL
						</Nav.Link>
						<Nav.Link
							className="NavItem"
							href="https://github.com/ojhaarjun1/"
							target="_blank"
						>
							<FontAwesomeIcon
								icon={faGithub}
							/>
						</Nav.Link>
						<Nav.Link
							className="NavItem"
							href="https://www.linkedin.com/in/kumarmallikarjuna/"
							target="_blank"
						>
							<FontAwesomeIcon
								icon={
									faLinkedin
								}
							/>
						</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		</div>
	);
}

export default NavBar;
